import React from 'react'
import { Text, useWindowDimensions, View } from 'react-native'
import { useCssStyle } from '../../../customHook/getCssStyle';
import { getCleanUrl } from '../../../utils/Helper';
import CustomPressable from '../../customPressable/customPressable';
import { ImageComp } from '../../Image/Image';
import RenderHTML from 'react-native-render-html';
import { useNavigation } from '@react-navigation/native';
import { INFO_MULTIPLE, SUB_WIDGET_LIST } from '../../../navigation/StackNavigator/routes';

const InfoMultipleWidget = (props) => {
    const { listItemData = [], widget: widgetData, handleOnWidgetClick } = props || {};

    const getStyles = useCssStyle();
    const { width } = useWindowDimensions()

    const navigation = useNavigation();

    if (!listItemData.length) {
        return null;
    }

    const handleWidgetClick = () => {
        navigation.navigate(SUB_WIDGET_LIST, { listItemData, widget: widgetData })
    }
    const customWidgetTitleStyle = getStyles([
        'infoMultipleHeaderTitle',
        `infoMultipleHeaderTitle_${widgetData.widgetMetaHtmlId}`,
        `infoMultipleHeaderTitle_${widgetData.id}`
    ]);


    const customWidgetSubTitleStyle = getStyles([
        'infoMultipleHeaderSubtitle',
        `infoMultipleHeaderSubtitle_${widgetData.widgetMetaHtmlId}`,
        `infoMultipleHeaderSubtitle_${widgetData.id}`
    ]);

    return (
        <CustomPressable
            onPress={() => handleWidgetClick(widgetData)} 
            key={widgetData.id} 
            style={getStyles( ['infoMultiplesWidgetContainer', `infoMultiplesWidgetContainer_${widgetData.widgetMetaHtmlId}`, `infoMultiplesWidgetContainer_${widgetData.id}`])} 
            id={`infoMultiplesWidgetContainer infoMultiplesWidgetContainer_${widgetData.widgetMetaHtmlId} infoMultiplesWidgetContainer_${widgetData.id}`} 
        >
            {widgetData.widgetHeaderImageUrl && (
                <ImageComp
                    source={getCleanUrl(widgetData.widgetHeaderImageUrl)}
                    style={getStyles(['infoMultipleImageStyle', `infoMultipleImageStyle_${widgetData.widgetMetaHtmlId}`, `infoMultipleImageStyle_${widgetData.id}`])}
                    id={`infoMultipleImageStyle infoMultipleImageStyle_${widgetData.widgetMetaHtmlId} infoMultipleImageStyle_${widgetData.id}`}
                />
            )}
            {widgetData.displayName && (
                <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetTitleStyle}
                    source={{ html: widgetData.displayName }}
                    systemFonts={Array.isArray(customWidgetTitleStyle?.fontFamily) ? customWidgetTitleStyle?.fontFamily : [customWidgetTitleStyle.fontFamily]}
                    id={`infoMultipleHeaderTitle infoMultipleHeaderTitle_${widgetData.widgetMetaHtmlId} infoMultipleHeaderTitle_${widgetData.id}`}
                />
            )}
            {widgetData.widgetDesc && (
                <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetSubTitleStyle}
                    source={{ html: widgetData.widgetDesc }}
                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                    id={`infoMultipleHeaderSubtitle infoMultipleHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}
                    
                />
            )}
            {widgetData.buttonTitle &&
                <View 
                    style={getStyles(['infoMultipleButtonContainer', `infoMultipleButtonContainer_${widgetData.widgetMetaHtmlId}`, `infoMultipleButtonContainer_${widgetData.id}`])}
                    id={`infoMultipleButtonContainer infoMultipleButtonContainer_${widgetData.widgetMetaHtmlId} infoMultipleButtonContainer_${widgetData.id}`}
                >
                    <Text
                        style={getStyles(['infoMultipleButtonContainerText', `infoMultipleButtonContainerText_${widgetData.widgetMetaHtmlId}`, `infoMultipleButtonContainerText_${widgetData.id}`])}
                        id={`infoMultipleButtonContainerText infoMultipleButtonContainerText_${widgetData.widgetMetaHtmlId} infoMultipleButtonContainerText_${widgetData.id}`}
                    >
                        {widgetData.buttonTitle}
                    </Text>
                </View>
            }
        </CustomPressable>
    );
}

export default InfoMultipleWidget
